import Vue from "vue";
import Router from "vue-router";

const TheContainer = () => import("@/containers/TheContainer");
const Ads = () => import("@/views/Ads");
const Hoods = () => import("@/views/Hoods");
const PublisherBlacklist = () => import("@/views/PublisherBlacklist");
const Scraper = () => import("@/views/Scraper");
const Logout = () => import("@/views/Logout");
const UserLogin = () => import("@/views/Login");

Vue.use(Router);

export default new Router({
  mode: "hash", // https://router.vuejs.org/api/#mode
  linkActiveClass: "active",
  scrollBehavior: () => ({ y: 0 }),
  routes: configRoutes(),
});

function configRoutes() {
  return [
    {
      path: "/",
      redirect: "/",
      name: "Home",
      component: TheContainer,
      children: [
        {
          path: "/",
          name: "Oglasi",
          component: Ads,
        },
        {
          path: "/Hoods",
          name: "Kvartovi",
          component: Hoods,
        },
        {
          path: "/PublisherBlacklist",
          name: "Blacklist agencija",
          component: PublisherBlacklist,
        },
        {
          path: "/Scraper",
          name: "Scraper",
          component: Scraper,
        },
      ],
    },
    {
      path: "/logout",
      name: "Logout",
      component: Logout,
    },
    {
      path: "/login/:nextUrl?",
      name: "UserLogin",
      component: UserLogin,
    },
  ];
}
